import React from "react"
import AddLocationModal from "@/modules/profile/LocationSettings/components/AddLocationModal"

import { useRecoilValue } from "recoil"
import { isPayingUserSelector, locationsSelector, userAtom } from "@/atoms/userAtom"
import { useTranslation } from "react-i18next"
import SettingSection from "../../shared/SettingSection"
import DeleteLocationModal from "./components/DeleteLocationModal"
import EditLocationModal from "./components/EditLocationModal"
import KosmoButton from "@/UI/Buttons/KosmoButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import LocationDetails from "@/modules/shared/LocationsList/components/LocationDetails"
import { PROFILE_PAGE_PATH } from "@/constants/routes"
import { useSandboxRouter } from "@/hooks/useSandboxRouter"
import PreventWithModal from "@/UI/PreventWithModal"

interface ILocationSettingsProps {}

const LocationSettings: React.FC<ILocationSettingsProps> = () => {
  const { t } = useTranslation()
  const { sandboxRouter } = useSandboxRouter()
  const user = useRecoilValue(userAtom)
  const isPayingUser = useRecoilValue(isPayingUserSelector)
  const countryCode = user?.org?.country
  const stores = useRecoilValue(locationsSelector)
  const addLocationButton = (
    <KosmoButton type="primary">
      <div className="flex items-center gap-x-2">
        <FontAwesomeIcon icon={faPlus} color="#FFF" />
        <p>{t("profile.AddStoreModal.addNewLocation")}</p>
      </div>
    </KosmoButton>
  )

  return (
    <SettingSection
      title={t("common.locations")}
      actionButton={
        <div className="flex justify-end">
          {isPayingUser || stores?.length < 1 ? (
            <AddLocationModal button={addLocationButton} />
          ) : (
            <PreventWithModal
              enable={!isPayingUser}
              label={t("onboarding.freePlanBannerDescription")}
              cta={{
                label: t("profile.planCard.startNow"),
                onClick: () => sandboxRouter.push(`${PROFILE_PAGE_PATH}/?p=plans`),
              }}
            >
              {addLocationButton}
            </PreventWithModal>
          )}
        </div>
      }
    >
      <div className="flex gap-y-1 w-full flex-col">
        {user?.stores && user?.stores?.length > 0 && (
          <>
            {user?.stores?.map((store, index) => (
              <div
                id={`store-card-${index}`}
                key={index}
                className="flex flex-row border p-3 rounded-xl mb-3 justify-between"
              >
                <LocationDetails
                  id={store.id || ""}
                  alias={store.alias || ""}
                  countryCode={countryCode}
                  address={store.address}
                  buildingNumber={store.buildingNumber}
                  name={store.name || ""}
                  phone={store.phone}
                  email={store.email}
                />
                <div className="flex flex-row space-x-2 items-center">
                  <EditLocationModal store={store} />
                  <DeleteLocationModal store={store} />
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </SettingSection>
  )
}

export default LocationSettings
